
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kOCLQ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $2e824053050bfb9f$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Russian
var $2e824053050bfb9f$export$2e2bcd8739ae039 = {
    'confluence-analytics-chart.default-loading-text': "\u041E\u0431\u043D\u043E\u0432\u043B\u0435\u043D\u0438\u0435 \u0430\u043D\u0430\u043B\u0438\u0442\u0438\u043A\u0438\u2026",
    'confluence-analytics-chart.tooltip.no-views-data': "\u041D\u0435\u0442 \u0434\u0430\u043D\u043D\u044B\u0445",
    'confluence-analytics-chart.tooltip.views-overall': "{count, plural, one {{count}\xa0\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440} few {{count}\xa0\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430} many {{count}\xa0\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u043E\u0432} other {{count}\xa0\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430}}",
    'confluence-analytics-chart.tooltip.views-today-so-far': "{count, plural, one {{count}\xa0\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440 \u043D\u0430 \u0434\u0430\u043D\u043D\u044B\u0439 \u043C\u043E\u043C\u0435\u043D\u0442} few {{count}\xa0\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u043D\u0430 \u0434\u0430\u043D\u043D\u044B\u0439 \u043C\u043E\u043C\u0435\u043D\u0442} many {{count}\xa0\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u043E\u0432 \u043D\u0430 \u0434\u0430\u043D\u043D\u044B\u0439 \u043C\u043E\u043C\u0435\u043D\u0442} other {{count}\xa0\u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u0430 \u043D\u0430 \u0434\u0430\u043D\u043D\u044B\u0439 \u043C\u043E\u043C\u0435\u043D\u0442}}",
    'confuence-analytics-chart.accessible-table.caption': "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u044B \u0441\u0442\u0440\u0430\u043D\u0438\u0446",
    'confuence-analytics-chart.accessible-table.header.date': "\u0414\u0430\u0442\u0430",
    'confuence-analytics-chart.accessible-table.header.view-count': "\u041F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u044B",
    'confuence-analytics-chart.accessible-table.no-view-count-data': "\u041D\u0435\u0442 \u043F\u0440\u043E\u0441\u043C\u043E\u0442\u0440\u043E\u0432"
};

});


//# sourceMappingURL=ru.7f739454.js.map
